import { useMemo } from "react";
import { css } from "@emotion/css";
import { ControlGroup } from "@blueprintjs/core";
import { ILayoutProps } from "../types";
import { doHidden } from "components/Template/utils";
import { IGroup } from "components/Template/types";
import Validate from "components/Template/Validate";
import "./Group.scss";

export interface IGroupProps extends ILayoutProps {
  template: IGroup;
}

const flexStyles = (template: IGroup) =>
  template.inline && template.layout
    ? css`
        ${template.layout.map(
          (v, i) => css`
            & > div:nth-child(${i + 1}) {
              flex: ${v} 1 auto;
            }
          `
        )}
      `
    : "";

const Group = (props: React.PropsWithChildren<IGroupProps>) => {
  const { template, metadata } = props;

  const style = useMemo(() => flexStyles(template), [template]);

  if (doHidden(props)) {
    if (!metadata.hiddenInput.includes(template.name)) {
      metadata.hiddenInput.push(template.name);
    }
    return null;
  } else {
    if (metadata.hiddenInput.includes(template.name)) {
      metadata.hiddenInput = metadata.hiddenInput.filter((i) => i === template.name);
    }
  }

  return (
    <Validate
      {...props}
      className={`${template.label ? "level-container" : ""} anchor-${template.name}`}
      label={template.label}
      showInfo
    >
      <ControlGroup className={style} key={template.name} id={template.name} vertical={!Boolean(template.inline)}>
        {props.children}
      </ControlGroup>
    </Validate>
  );
};

export default Group;
